export const generateDefaultCenterFaq = (center) => {
  const hasDetoxService = center.treatment_services
    ? center.treatment_services.some((service) =>
        service.toLowerCase().includes('detox')
      )
    : false

  const detoxFaq = {
    question: hasDetoxService ? `Does ${center.title} offer detox?` : '',
    answer: hasDetoxService
      ? `Yes, we offer ${center.treatment_services
          .find((service) => service.toLowerCase().includes('detox'))
          .toLowerCase()}.`
      : ''
  }

  const faqSchema = [
    {
      question: center.pricing_label
        ? `How much does ${center.title} cost?`
        : '',
      answer: center.pricing_label
        ? `While costs may vary due to program length and insurance benefits, it typically costs ${center.pricing_label}.`
        : ''
    },
    {
      question: `What therapies does ${center.title} offer?`,
      answer:
        center.treatment_therapies && center.treatment_therapies.length > 0
          ? `The following therapies are included: ${center.treatment_therapies
              .slice(0, 2)
              .map((therapy) => therapy.toLowerCase())
              .join(', ')} and more.`
          : ''
    },
    {
      question: `Where is ${center.title} located?`,
      answer: `${center.location_label || ''}.`
    },
    {
      question: center.insurance_description
        ? `What insurance does ${center.title} accept?`
        : '',
      answer: center.insurance_description || ''
    },
    {
      question: 'How long is treatment?',
      answer: center.length_label
        ? `The typical length is ${center.length_label}.`
        : ''
    },
    detoxFaq,
    {
      question: `What levels of care does ${center.title} offer?`,
      answer:
        center.treatment_services && center.treatment_services.length > 0
          ? `${center.title} provides ${center.treatment_services
              .slice(0, 2)
              .map((service) => service.toLowerCase())
              .join(', ')} and more.`
          : ''
    }
  ]

  return faqSchema
}
